import React, { PropsWithChildren } from 'react';
import styles from './Button.module.css';

export const Button = (
  props: JSX.IntrinsicAttributes &
    React.ClassAttributes<HTMLButtonElement> &
    React.ButtonHTMLAttributes<HTMLButtonElement> &
    PropsWithChildren,
) => <button type="button" className={styles.button} {...props} />;
